export const integratorRankingTrackers = {
  actions: {
    closeWelcomeModal: 'Ranking de Integradores: Saiu do modal de boas vindas',
    navigateBetweenMonths: 'Ranking de Integradores: Navegou entre os meses',
    summaryBanner:
      'Resumo do Ranking (Banner): Redirecionado para a página do Ranking',
  },
}
